import * as React from "react";
import renderUtils from "../../helpers/renderUtils";
import { useTranslation } from 'react-i18next';

export const useCleaningTableColumns = () => {
    const { t } = useTranslation();
    
    return [
        {
            label: "ID",
            field: "partId",
            sort: "desc",
            width: 53,
        },
        {
            label: t ? t("common.part_name") : "Nazwa części",
            field: "partName",
            sort: "desc",
            type: "tooltipImage",
            resolveImage: function (row) {
                return row.files[0];
            },
            width: 53,
        },
        {
            label: t("common.status"),
            field: "partStatus",
            sort: "desc",
            type: "custom",
            custom: function (column, row, history, internalReload, setInternalReload, setLoader, disableRule, externalState) {
                return renderUtils.renderPartStatus(row.partStatus, "", false, t)
            },
            width: 53,
        },
        {
            label: t("object_types.format"),
            field: "formatName",
            sort: "desc",
            badgeType: "badge-primary",
            type: "badge",
            width: 53,
        },
    ];
};

// Legacy export for backward compatibility
const columns = (t) => [

    {
        label: "ID",
        field: "partId",
        sort: "desc",
        width: 53,
    },

    {
        label: t ? t("common.part_name") : "Nazwa części",
        field: "partName",
        sort: "desc",
        type: "tooltipImage",
        resolveImage: function (row) {
            return row.files[0];
        },
        width: 53,
    },
    {
        label: t ? t("common.status") : "Status",
        field: "partStatus",
        sort: "desc",
        type: "custom",
        custom: function (column, row, history, internalReload, setInternalReload, setLoader, disableRule, externalState) {
            return renderUtils.renderPartStatus(row.partStatus)
        },
        width: 53,
    },
    {
        label: t ? t("common.format") : "Format",
        field: "formatName",
        sort: "desc",
        badgeType: "badge-primary",
        type: "badge",
        width: 53,
    },

];

export default columns;